// 개발요청 — AX 검토 칸(D5a → 2판 V3: 상세 오른쪽 칸을 없애고 «② 검토»·«③ 진행·완료» 카드 안에서 바로 고친다).
//   ② 진행 여부·사유·통합 대상·회차 우선순위·예정 시작·예정 완료·상세 요구사항(+ 진행이 아니면 상태 접수·검토)
//   ③ 상태·완료일·사용 위치 · ① 머리 줄의 공개 전환 · 요청자 연결(DevRequestPart1Tools).
//   완료 확인 «수정 필요»의 «테스트로 되돌리기»는 상세의 «할 일» 상자로 옮겼다.
// 🔴 AX 에게만 그린다 — 상세(DevRequestDetail)가 서버 /me 의 is_ax 로 «고치기»·① 머리 단추를 보일지 정한다.
//    review·visibility·requester·users/search 는 서버가 require_ax 로 막는다.
// 🔴 규칙의 정본은 서버(devreq_rules.validate_review) — 진행이 아닌 요청의 대기·개발 중·테스트·완료를 끄는 것은 미리 보여 주는 편의다.
//    400·409 문구는 칸 위에 그대로 보인다.
// 🔴 바뀐 칸만 review 로 보낸다(키 없음 = 안 바꿈 · 서버도 보낸 칸만 본다).
// 🔴 ② 에서 진행 여부를 진행이 아닌 것(미정 포함)으로 고르고 지금 상태가 대기·개발 중·테스트·완료이면 상태(접수·검토)를
//    함께 고르게 한다 — 상태를 안 바꾸면 서버가 409(HOLD_STATUS_ONLY · PROCEED_ONLY)를 낸다. 고르기 전엔 «저장»이 꺼져 있다.
// 🔴 서버 응답(serialize_for)에는 requester_id 가 없다 → «요청자 연결·바꾸기» 단추는 AX 에게 늘 보인다.
//    «요청자 미연결» 배지는 서버가 requester_id 를 null 로 실어 줄 때만 보인다(키가 없으면 단정하지 않는다).
// 🔴 철회된 요청은 서버 review 가 409(«철회된 요청입니다.») — 상세가 ②③ «고치기»를 그리지 않는다(이 칸도 칸·저장을 끈다).
//    공개 전환·요청자 연결은 서버가 받는다.
import { useEffect, useRef, useState } from 'react';
import { devreqAPI } from '../../api/client';
import { confirmDialog } from '../../components/AppDialog';
import { COLORS, btn, input as inputStyle } from '../../utils/uiStyles';
import {
  DECISIONS, DETAIL_STATES, HOLD_DECISIONS, PROCEED_STATUSES, STATUSES, errorText, text, usageLinkKind,
} from './devreqLabels';

// 서버 devreq_rules.REVIEW_FIELDS 를 카드별로 나눈 칸.
const PART_FIELDS = {
  part2: ['decision', 'decision_reason', 'merged_into_id', 'priority', 'plan_start', 'plan_end', 'detail_state'],
  part3: ['status', 'done_on', 'usage_location'],
};
const PART_TITLES = { part2: '② 검토 편집', part3: '③ 진행·완료 편집' };
const REASON_MAX = 500;   // = devreq_rules.REASON_MAX
const USAGE_MAX = 300;    // = devreq_rules.USAGE_LOCATION_MAX
const CANDIDATE_LIMIT = 20;
const SAVE_FAILED = '검토를 저장하지 못했습니다.';
const VISIBILITY_FAILED = '공개 범위를 바꾸지 못했습니다.';
const REQUESTER_FAILED = '요청자를 연결하지 못했습니다.';
const SEARCH_FAILED = '사용자를 찾지 못했습니다.';
const CANDIDATES_FAILED = '통합 대상 목록을 불러오지 못했습니다.';
const PROCEED_ONLY_HINT = '진행으로 정한 요청만 대기·개발 중·테스트·완료로 옮길 수 있습니다.';
// ② 의 상태 칸 안내 — 서버 devreq_rules.HOLD_STATUS_ONLY · PROCEED_ONLY 와 같은 뜻.
const HOLD_STATUS_HINT = '보류·반려·통합으로 정한 요청의 상태는 접수·검토만 됩니다. 상태도 함께 바꿔 주세요.';
const UNDECIDED_STATUS_HINT = '진행으로 정한 요청만 대기·개발 중·테스트·완료에 둘 수 있습니다. 상태도 함께 바꿔 주세요.';
// 진행이 아닌 요청이 갈 수 있는 상태(접수·검토).
const HOLD_STATUSES = STATUSES.filter((s) => !PROCEED_STATUSES.includes(s));
export const WITHDRAWN_NOTICE = '철회된 요청입니다 — ②③ 은 고칠 수 없습니다(공개 전환·요청자 연결은 됩니다).';

const labelStyle = { display: 'block', marginBottom: '4px', color: COLORS.text, fontSize: '12px', fontWeight: 700 };
const boxStyle = { marginBottom: '10px', minWidth: 0 };
const noteStyle = { marginTop: '4px', color: COLORS.textSub, fontSize: '12px' };
const warnStyle = { ...noteStyle, color: COLORS.dangerText };
const fieldStyle = { ...inputStyle, fontSize: '13px', padding: '7px 10px' };
const pill = (background, color) => ({
  display: 'inline-block', padding: '2px 8px', borderRadius: '999px', fontSize: '11px', fontWeight: 700, background, color, whiteSpace: 'nowrap',
});

const fieldId = (name) => `devreq-review-${name}`;
const str = (value) => (value === null || value === undefined ? '' : String(value));
// 날짜 칸 — 'YYYY-MM-DD' 앞 10자(<input type="date"> 값) · 빈 값은 ''.
const day = (value) => {
  const m = typeof value === 'string' ? /^(\d{4}-\d{2}-\d{2})/.exec(value) : null;
  return m ? m[1] : '';
};

// 상세 응답 → 칸 값. 통합 대상은 상세의 merged_into(대표 건) id.
function initialOf(item) {
  return {
    decision: str(item.decision),
    decision_reason: str(item.decision_reason),
    merged_into_id: item.merged_into?.id ?? null,
    priority: str(item.priority),
    plan_start: day(item.plan_start),
    plan_end: day(item.plan_end),
    detail_state: str(item.detail_state),
    status: str(item.status),
    done_on: day(item.done_on),
    usage_location: str(item.usage_location),
  };
}

// 보낼 값 · 비교 값 — 글자는 앞뒤 공백을 뗀다(서버도 뗀다) · 빈 칸은 null(미정·비움) · 우선순위는 수.
function wire(name, value) {
  if (name === 'merged_into_id') return value ?? null;
  if (name === 'priority') return value === '' ? null : Number(value);
  const trimmed = String(value ?? '').trim();
  return trimmed === '' ? null : trimmed;
}

// 한 카드(② 또는 ③)의 편집 칸 — 저장 성공이면 onSaved(상세가 고치기를 닫고 다시 읽는다) · 실패는 칸 위 문구(고치기 그대로).
//   dirtyRef — 바뀐 칸이 있는지 상세에 알린다(다른 카드 «고치기»로 넘어갈 때 «고치던 내용을 버릴까요?»).
function ReviewEditor({ item, base, part, onSaved, onCancel, dirtyRef }) {
  const [values, setValues] = useState(() => ({ ...base }));
  const [holdStatus, setHoldStatus] = useState('');     // ② 에서 진행이 아니게 고를 때 함께 보내는 상태(접수·검토)
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [candidates, setCandidates] = useState(null);   // null = 아직 안 불렀다
  const [candError, setCandError] = useState('');
  const [mergeQ, setMergeQ] = useState('');
  const busyRef = useRef(false);
  const aliveRef = useRef(true);
  const candLoadRef = useRef(false);
  const firstRef = useRef(null);

  const isPart2 = part === 'part2';
  const merging = isPart2 && values.decision === '통합';
  const locked = item.withdrawn === true;

  useEffect(() => {
    aliveRef.current = true;
    firstRef.current?.focus();
    return () => { aliveRef.current = false; };
  }, []);

  // 통합 대상 후보 — 같은 회차의 요청(통합을 고를 때 한 번 부른다).
  useEffect(() => {
    if (!merging || candLoadRef.current) return;
    candLoadRef.current = true;
    devreqAPI.list({ round_id: item.round_id })
      .then((r) => { if (aliveRef.current) setCandidates(Array.isArray(r?.data?.items) ? r.data.items : []); })
      .catch(async (err) => {
        const message = await errorText(err, CANDIDATES_FAILED);
        if (aliveRef.current) setCandError(message);
      });
  }, [merging, item.round_id]);

  const setField = (name, value) => setValues((prev) => ({ ...prev, [name]: value }));

  // 통합이 아니면 대표를 보내지 않는다 — 서버가 비운다(devreq_rules.validate_review 규칙 1).
  const changed = PART_FIELDS[part].filter((name) => (name === 'merged_into_id' && !merging
    ? false
    : wire(name, values[name]) !== wire(name, base[name])));
  // ② — 진행이 아니게(미정 포함) 고르고 지금 상태가 대기·개발 중·테스트·완료면 상태를 함께 보낸다.
  const needStatus = isPart2 && values.decision !== '진행' && PROCEED_STATUSES.includes(base.status);
  // ③ — 진행 여부는 서버 값으로 본다(한 번에 한 카드만 고친다 · ② 의 고치던 값은 모른다).
  const proceedOff = !isPart2 && base.decision !== '진행';
  const hold = isPart2 && HOLD_DECISIONS.includes(values.decision);
  const reasonMissing = hold && wire('decision_reason', values.decision_reason) === null;
  const targetMissing = merging && values.merged_into_id === null;
  const statusMissing = needStatus && holdStatus === '';
  const done = !isPart2 && values.status === '완료';
  const usage = wire('usage_location', values.usage_location);
  // 사용 위치 형식 — 서버 usage_location_value 와 같은 정규식(devreqLabels.usageLinkKind).
  const usageBad = !isPart2 && usage !== null && usageLinkKind(usage) === 'text';
  // 완료 — 완료일만 필수(사용 위치는 넣으면 형식만 본다 · 서버 validate_review 규칙 4).
  const doneMissing = done && values.done_on === '';
  const canSave = !locked && (changed.length > 0 || needStatus)
    && !reasonMissing && !targetMissing && !statusMissing && !doneMissing && !usageBad && !busy;
  const dirty = changed.length > 0 || (needStatus && holdStatus !== '');

  useEffect(() => {
    if (dirtyRef) dirtyRef.current = dirty;
  });

  const save = async () => {
    if (!canSave || busyRef.current) return;
    const body = {};
    changed.forEach((name) => { body[name] = wire(name, values[name]); });
    if (needStatus) body.status = holdStatus;
    busyRef.current = true;
    setBusy(true);
    setError('');
    try {
      await devreqAPI.review(item.id, body);
      if (!aliveRef.current) return;
      onSaved?.();
    } catch (err) {
      const message = await errorText(err, SAVE_FAILED);
      if (aliveRef.current) setError(message);
    } finally {
      busyRef.current = false;
      if (aliveRef.current) setBusy(false);
    }
  };

  // 통합 대상 후보 — 같은 회차 · 자기 자신·통합된 건·철회된 건은 뺀다 · 번호·제목으로 거른다.
  const mergeTerm = mergeQ.trim().toLowerCase();
  const pickable = (candidates || []).filter((c) => c.id !== item.id && c.round_id === item.round_id
    && c.decision !== '통합' && !c.withdrawn);
  const shown = (mergeTerm
    ? pickable.filter((c) => str(c.req_no).toLowerCase().includes(mergeTerm) || str(c.title).toLowerCase().includes(mergeTerm))
    : pickable).slice(0, CANDIDATE_LIMIT);
  const chosen = pickable.find((c) => c.id === values.merged_into_id)
    || (item.merged_into?.id === values.merged_into_id ? item.merged_into : null);

  const required = (on) => (on ? <span aria-hidden="true" style={{ color: COLORS.dangerText }}> *</span> : null);
  const labelFor = (name, label, on = false) => (
    <label htmlFor={fieldId(name)} style={labelStyle}>{label}{required(on)}</label>
  );
  const dateField = (name, label, on = false) => (
    <div style={boxStyle}>
      {labelFor(name, label, on)}
      <input id={fieldId(name)} type="date" aria-label={label} aria-required={on} value={values[name]}
        onChange={(e) => setField(name, e.target.value)} style={fieldStyle} />
    </div>
  );

  const part2Fields = (
    <>
      <div style={boxStyle}>
        {labelFor('decision', '진행 여부')}
        <select id={fieldId('decision')} ref={firstRef} aria-label="진행 여부" value={values.decision}
          onChange={(e) => setField('decision', e.target.value)} style={fieldStyle}>
          <option value="">미정</option>
          {DECISIONS.map((v) => <option key={v} value={v}>{v}</option>)}
        </select>
      </div>
      <div style={boxStyle}>
        {labelFor('decision_reason', '사유', hold)}
        <textarea id={fieldId('decision_reason')} aria-label="사유" aria-required={hold} value={values.decision_reason}
          maxLength={REASON_MAX} rows={2} onChange={(e) => setField('decision_reason', e.target.value)}
          style={{ ...fieldStyle, resize: 'vertical' }} />
        {reasonMissing && <div style={warnStyle}>보류·반려·통합은 사유를 적어야 합니다.</div>}
      </div>
      {needStatus && (
        <div style={boxStyle}>
          {labelFor('hold_status', '상태', true)}
          <select id={fieldId('hold_status')} aria-label="상태" aria-required="true" value={holdStatus}
            onChange={(e) => setHoldStatus(e.target.value)} style={fieldStyle}>
            <option value="">골라 주세요</option>
            {HOLD_STATUSES.map((v) => <option key={v} value={v}>{v}</option>)}
          </select>
          <div style={statusMissing ? warnStyle : noteStyle}>{hold ? HOLD_STATUS_HINT : UNDECIDED_STATUS_HINT}</div>
        </div>
      )}
      {merging && (
        <div style={boxStyle}>
          <div style={labelStyle}>통합 대상{required(true)}</div>
          <div style={{ fontSize: '13px', marginBottom: '6px', overflowWrap: 'anywhere' }}>
            {chosen ? `→ ${text(chosen.req_no)} · ${text(chosen.title)}` : '대표 요청을 골라 주세요'}
          </div>
          <input type="search" aria-label="통합 대상 찾기" placeholder="요청번호·제목" value={mergeQ}
            onChange={(e) => setMergeQ(e.target.value)} style={fieldStyle} />
          {candError && <div style={warnStyle}>{candError}</div>}
          {!candError && candidates === null && <div style={noteStyle}>불러오는 중…</div>}
          {candidates !== null && shown.length === 0 && <div style={noteStyle}>고를 수 있는 요청이 없습니다</div>}
          {shown.length > 0 && (
            <ul aria-label="통합 대상 목록" style={{ listStyle: 'none', margin: '6px 0 0', padding: 0, maxHeight: '180px', overflowY: 'auto' }}>
              {shown.map((c) => {
                const picked = c.id === values.merged_into_id;
                return (
                  <li key={c.id}>
                    <button type="button" aria-pressed={picked} onClick={() => setField('merged_into_id', c.id)}
                      style={{ ...btn(picked ? 'accent' : 'secondary', 'sm'), width: '100%', textAlign: 'left', marginBottom: '4px', whiteSpace: 'normal', overflowWrap: 'anywhere', fontWeight: picked ? 700 : 500 }}>
                      {`${text(c.req_no)} · ${text(c.title)}`}
                    </button>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      )}
      <div style={boxStyle}>
        {labelFor('priority', '회차 우선순위')}
        <input id={fieldId('priority')} type="number" min={1} step={1} aria-label="회차 우선순위" placeholder="미정"
          value={values.priority} onChange={(e) => setField('priority', e.target.value)} style={fieldStyle} />
      </div>
      {dateField('plan_start', '예정 시작')}
      {dateField('plan_end', '예정 완료')}
      <div style={boxStyle}>
        {labelFor('detail_state', '상세 요구사항')}
        <select id={fieldId('detail_state')} aria-label="상세 요구사항" value={values.detail_state}
          onChange={(e) => setField('detail_state', e.target.value)} style={fieldStyle}>
          {/* 서버는 비우기를 받지 않는다 — 처음부터 빈 요청만 «—» 를 보이고 다시 고를 수는 없다. */}
          {base.detail_state === '' && <option value="" disabled>—</option>}
          {DETAIL_STATES.map((v) => <option key={v} value={v}>{v}</option>)}
        </select>
      </div>
    </>
  );

  const part3Fields = (
    <>
      <div style={boxStyle}>
        {labelFor('status', '상태')}
        <select id={fieldId('status')} ref={firstRef} aria-label="상태" value={values.status}
          onChange={(e) => setField('status', e.target.value)} style={fieldStyle}>
          {STATUSES.map((v) => (
            <option key={v} value={v} disabled={proceedOff && PROCEED_STATUSES.includes(v)}>{v}</option>
          ))}
        </select>
        {proceedOff && <div style={noteStyle}>{PROCEED_ONLY_HINT}</div>}
      </div>
      {dateField('done_on', '완료일', done)}
      {doneMissing && <div style={warnStyle}>완료에는 완료일이 필요합니다.</div>}
      <div style={boxStyle}>
        {labelFor('usage_location', '사용 위치')}
        <input id={fieldId('usage_location')} type="text" aria-label="사용 위치"
          placeholder="/경로 또는 https://주소" value={values.usage_location} maxLength={USAGE_MAX}
          onChange={(e) => setField('usage_location', e.target.value)} style={fieldStyle} />
        {usageBad && <div style={warnStyle}>사용 위치는 앱 안 경로(/ 로 시작) 또는 https:// 주소입니다.</div>}
      </div>
    </>
  );

  return (
    <div role="group" aria-label={PART_TITLES[part]} style={{ padding: '10px 14px 4px' }}>
      {error && (
        <div role="alert" style={{ marginBottom: '10px', padding: '8px 12px', borderRadius: '8px', background: COLORS.dangerSoft, color: COLORS.dangerText, fontSize: '13px', overflowWrap: 'anywhere' }}>
          {error}
        </div>
      )}
      {locked && (
        <div role="note" style={{ marginBottom: '10px', padding: '8px 12px', borderRadius: '8px', background: '#f3f4f6', color: COLORS.textSub, fontSize: '13px' }}>
          {WITHDRAWN_NOTICE}
        </div>
      )}
      {/* 철회된 요청은 칸을 한꺼번에 끈다(fieldset disabled). */}
      <fieldset disabled={locked} aria-label="검토 칸" style={{ border: 0, margin: 0, padding: 0, minWidth: 0 }}>
        {isPart2 ? part2Fields : part3Fields}
      </fieldset>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginBottom: '10px' }}>
        <button type="button" onClick={() => onCancel?.()} disabled={busy} style={btn('secondary', 'sm')}>취소</button>
        <button type="button" onClick={save} disabled={!canSave} style={{ ...btn('primary', 'sm'), opacity: canSave ? 1 : 0.5 }}>
          {busy ? '저장 중…' : '저장'}
        </button>
      </div>
    </div>
  );
}

// ① 머리 줄의 AX 단추 — 공개 전환(확인 대화) · 요청자 연결·바꾸기(사용자 찾기). 철회돼도 서버가 받는다.
//   성공하면 onChanged(상세·목록 다시 부르기) · 실패는 그 아래 문구.
export function DevRequestPart1Tools({ item, onChanged }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [linkOpen, setLinkOpen] = useState(false);
  const [userQ, setUserQ] = useState('');
  const [users, setUsers] = useState(null);             // null = 아직 안 찾았다
  const [searching, setSearching] = useState(false);
  const busyRef = useRef(false);
  const aliveRef = useRef(true);

  useEffect(() => {
    aliveRef.current = true;
    return () => { aliveRef.current = false; };
  }, []);

  const run = async (call, fallback, after) => {
    if (busyRef.current) return;
    busyRef.current = true;
    setBusy(true);
    setError('');
    try {
      await call();
      if (!aliveRef.current) return;
      after?.();
      onChanged?.();
    } catch (err) {
      const message = await errorText(err, fallback);
      if (aliveRef.current) setError(message);
    } finally {
      busyRef.current = false;
      if (aliveRef.current) setBusy(false);
    }
  };

  const isPrivate = item.visibility === 'private';
  const toggleVisibility = async () => {
    if (busyRef.current) return;
    const next = isPrivate ? 'public' : 'private';
    if (!(await confirmDialog(`${next === 'public' ? '공개' : '비공개'}로 바꿉니다. 요청자에게 알림이 갑니다.`))) return;
    run(() => devreqAPI.setVisibility(item.id, next), VISIBILITY_FAILED);
  };

  const searchUsers = async () => {
    const q = userQ.trim();
    if (!q || searching) return;
    setSearching(true);
    setError('');
    try {
      const r = await devreqAPI.searchUsers(q);
      if (aliveRef.current) setUsers(Array.isArray(r?.data) ? r.data : []);
    } catch (err) {
      const message = await errorText(err, SEARCH_FAILED);
      if (aliveRef.current) setError(message);
    } finally {
      if (aliveRef.current) setSearching(false);
    }
  };
  const closeLink = () => { setLinkOpen(false); setUsers(null); setUserQ(''); };
  const linkRequester = (user) => run(() => devreqAPI.setRequester(item.id, user.id), REQUESTER_FAILED, closeLink);

  // 배지만 서버가 requester_id 를 null 로 실어 준 요청에 — 키가 없으면(지금 서버) 미연결이라 단정하지 않는다.
  //   연결·바꾸기 단추는 그와 무관하게 늘 있다(같은 사람을 고르면 서버는 바뀐 것 없이 200).
  const unlinked = item.requester_id === null;
  const below = { flexBasis: '100%', boxSizing: 'border-box', fontSize: '13px', fontWeight: 400 };

  return (
    <>
      {unlinked && <span style={pill(COLORS.warnSoft, COLORS.warn)}>요청자 미연결</span>}
      <button type="button" onClick={toggleVisibility} disabled={busy} style={btn('secondary', 'sm')}>
        {isPrivate ? '공개로' : '비공개로'}
      </button>
      {!linkOpen && (
        <button type="button" onClick={() => setLinkOpen(true)} disabled={busy} style={btn('accent', 'sm')}>요청자 연결·바꾸기</button>
      )}
      {linkOpen && (
        <div style={{ ...below, padding: '8px', borderRadius: '8px', background: COLORS.surface, color: COLORS.text }}>
          <div style={{ display: 'flex', gap: '6px' }}>
            <input type="search" aria-label="사용자 찾기" placeholder="이름·이메일" value={userQ}
              onChange={(e) => setUserQ(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); searchUsers(); } }}
              style={fieldStyle} />
            <button type="button" onClick={searchUsers} disabled={!userQ.trim() || searching} style={btn('secondary', 'sm')}>찾기</button>
            <button type="button" onClick={closeLink} style={btn('secondary', 'sm')}>취소</button>
          </div>
          {users !== null && users.length === 0 && <div style={noteStyle}>찾은 사용자가 없습니다</div>}
          {users !== null && users.length > 0 && (
            <ul aria-label="찾은 사용자" style={{ listStyle: 'none', margin: '6px 0 0', padding: 0 }}>
              {users.map((u) => (
                <li key={u.id}>
                  <button type="button" onClick={() => linkRequester(u)} disabled={busy}
                    style={{ ...btn('secondary', 'sm'), width: '100%', textAlign: 'left', marginBottom: '4px', whiteSpace: 'normal', overflowWrap: 'anywhere' }}>
                    {`${text(u.name)} · ${text(u.email)}`}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
      {error && (
        <div role="alert" style={{ ...below, padding: '6px 10px', borderRadius: '8px', background: COLORS.dangerSoft, color: COLORS.dangerText, overflowWrap: 'anywhere' }}>
          {error}
        </div>
      )}
    </>
  );
}

// 카드 편집 칸 — 상세가 «② 검토 고치기»·«③ 진행·완료 고치기»(또는 «할 일»의 «검토 시작»)로 연다.
export default function DevRequestReviewPanel({ item, part, onSaved, onCancel, dirtyRef }) {
  // 불러오는 중·가린 상세(AX 에게는 오지 않는다)는 없다.
  if (!item || item.masked || !PART_FIELDS[part]) return null;
  const base = initialOf(item);
  // 서버의 ②③ 값이 바뀌면(저장 뒤 다시 읽기) 칸을 새 값으로 다시 깐다 — 메모·첨부로 상세를 다시 읽을 때는 고치던 칸이 남는다.
  return (
    <ReviewEditor key={`${item.id}:${part}:${JSON.stringify(base)}`} item={item} base={base} part={part}
      onSaved={onSaved} onCancel={onCancel} dirtyRef={dirtyRef} />
  );
}
